import { createContext, useContext, useEffect, useState } from "react";

import { 
    authenticateUser, 
    authorizeUser, 
    deauthenticateUser, 
    deleteAccount, 
    updateUser 
} from "./authentication.services";

export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children, loading }) => {

    const [userAccount, setUserAccount] = useState();
    const [isAuthenticated, setIsAuthenticated] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [token, setToken] = useState();

    /** authentication */
    const loginUser = async (email, password) => {
        try {
            setIsLoading(true);
            const response = await authenticateUser(email, password);
            const resp = await response.json();
            if (resp?.error) {
                setIsAuthenticated(false);
                return resp;
            }
            if (resp?.account) {
                setIsAuthenticated(true);
                setUserAccount(resp?.account);
                setToken(resp?.token);
                localStorage.setItem('rwactoken', resp?.token);
                return resp;
            }
        } catch (error) {
            console.log({error});
            return ({error: 'Login failed! Something went wrong.'});
        }finally{
            setIsLoading(false);
        }
    }


    useEffect(() => {
        const getUserData = async (token) => {
            try {
                const response = await authorizeUser(token);
                const resp = await response.json();
                return resp;
            } catch (error) {
                return ({error});
            }
        }
        (async() => {
            const getToken = new Promise((resolve, reject) => {
                const tk = localStorage.getItem('rwactoken');
                if(tk) resolve(tk)
                else {
                    reject('no access token found!');
                    setIsAuthenticated(false);
                }
            });
            try {
                  const acToken = await getToken;
                  setToken(acToken);
                  const userData = await getUserData(acToken);
                 
                  if (userData?.error) {
                    setIsAuthenticated(false);
                    console.log({isAuthenticated})
                    return;
                  }
                  
                  setUserAccount(userData);
                  setIsAuthenticated(true);
                  console.log({isAuthenticated})
            } catch (error) {
                console.log({error});
            }
            
        })();
    }, [isAuthenticated]);

    return (
        <AuthenticationContext.Provider
            value={{
                userAccount,
                isAuthenticated,
                isLoading,
                token,
                loginUser
            }}
        >
            {children}
        </AuthenticationContext.Provider>
    );
}

export const UseAuthentication = () => useContext(AuthenticationContext);